import { render, staticRenderFns } from "./VirtualNodes.vue?vue&type=template&id=272faab5"
import script from "./VirtualNodes.vue?vue&type=script&lang=ts"
export * from "./VirtualNodes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports